import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  isLoading?: boolean;
  variant?: "primary" | "secondary" | "outline";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  isLoading = false,
  variant = "primary",
  size = "lg",
  fullWidth = false,
  className = "",
  disabled,
  ...props
}) => {
  // Base styles
  const baseStyles =
    "rounded-lg font-medium font-roboto transition-all disabled:opacity-50 disabled:cursor-not-allowed";

  // Variant styles
  const variantStyles = {
    primary:
      "bg-[#0046A7] text-[#FFFEF8] border border-[#0046A7] hover:bg-[#003580] disabled:hover:bg-[#0046A7]",
    secondary:
      "bg-gray-600 text-white hover:bg-gray-700 disabled:hover:bg-gray-600",
    outline:
      "border border-[#0095FF] bg-[#EDF8FF] text-[#0046A7] hover:bg-[#EDF8FF] disabled:hover:bg-[#EDF8FF]",
  };

  // Size styles
  const sizeStyles = {
    sm: "h-10 text-sm px-4",
    md: "h-12 text-base px-6",
    lg: "h-14 text-base px-8",
  };

  // Width styles
  const widthStyles = fullWidth ? "w-full" : "";

  // Combine all styles
  const buttonClasses =
    `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyles} ${className}`.trim();

  return (
    <button
      className={buttonClasses}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <span
          className={`h-5 w-5 animate-spin border-2 ${
            variant === "outline" ? "border-[#0046A7]" : "border-white"
          } rounded-full border-t-transparent inline-block`}
        ></span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
